import { RouteRecordRaw } from 'vue-router';
import reportRouter from './reportRouter';

const adminRouters: Array<RouteRecordRaw> = [
   ...reportRouter,
];

export default adminRouters;
